<!-- card 6 -->
<div
  class="w-full rounded border border-[#e0e6ed] bg-white p-5 shadow-[4px_6px_10px_-3px_#bfc9d4] dark:border-[#1b2e4b] dark:bg-[#191e3a] dark:shadow-none"
>
  <div class="text-[#515365] dark:text-white-light">
    <form class="space-y-5" [formGroup]="form">
     

    <div>
        <label for="code">Code:</label>
        <input id="code" type="text" placeholder="Enter Code" class="form-input" formControlName="code" />
        <form-error [form]="form" controlName="code" [validations]="MasterProviderFormValidations.code"></form-error>
    </div>
    
    <div>
        <label for="name">Name:</label>
        <input id="name" type="text" placeholder="Enter Name" class="form-input" formControlName="name" />
        <form-error [form]="form" controlName="name" [validations]="MasterProviderFormValidations.name"></form-error>
    </div>
    
    <div>
        <label for="user">User:</label>
        <input id="user" type="text" placeholder="Enter User" class="form-input" formControlName="user" />
        <form-error [form]="form" controlName="user" [validations]="MasterProviderFormValidations.user"></form-error>
    </div>
    
    <div>
        <label for="password">Password:</label>
        <input id="password" type="text" placeholder="Enter Password" class="form-input" formControlName="password" />
        <form-error [form]="form" controlName="password" [validations]="MasterProviderFormValidations.password"></form-error>
    </div>
    
    <div>
        <label for="secret_code">Secret Code:</label>
        <input id="secret_code" type="text" placeholder="Enter Secret Code" class="form-input" formControlName="secret_code" />
        <form-error [form]="form" controlName="secret_code" [validations]="MasterProviderFormValidations.secret_code"></form-error>
    </div>
    
    <div>
        <label for="base_url">Base URL:</label>
        <input id="base_url" type="text" placeholder="Enter Base URL" class="form-input" formControlName="base_url" />
        <form-error [form]="form" controlName="base_url" [validations]="MasterProviderFormValidations.base_url"></form-error>
    </div>
    
    <div>
        <label for="method">Method:</label>
        <input id="method" type="text" placeholder="Enter Method" class="form-input" formControlName="method" />
        <form-error [form]="form" controlName="method" [validations]="MasterProviderFormValidations.method"></form-error>
    </div>
    
    <div>
        <label for="inq_param">Inquiry Parameter:</label>
        <input id="inq_param" type="text" placeholder="Enter Inquiry Parameter" class="form-input" formControlName="inq_param" />
        <form-error [form]="form" controlName="inq_param" [validations]="MasterProviderFormValidations.inq_param"></form-error>
    </div>
    
    <div>
        <label for="pay_param">Payment Parameter:</label>
        <input id="pay_param" type="text" placeholder="Enter Payment Parameter" class="form-input" formControlName="pay_param" />
        <form-error [form]="form" controlName="pay_param" [validations]="MasterProviderFormValidations.pay_param"></form-error>
    </div>
    
    <div>
        <label for="adv_param">Advice Parameter:</label>
        <input id="adv_param" type="text" placeholder="Enter Advice Parameter" class="form-input" formControlName="adv_param" />
        <form-error [form]="form" controlName="adv_param" [validations]="MasterProviderFormValidations.adv_param"></form-error>
    </div>
    
    <div>
        <label for="reversal_param">Reversal Parameter:</label>
        <input id="reversal_param" type="text" placeholder="Enter Reversal Parameter" class="form-input" formControlName="reversal_param" />
        <form-error [form]="form" controlName="reversal_param" [validations]="MasterProviderFormValidations.reversal_param"></form-error>
    </div>
    
    <div>
        <label for="inq_url">Inquiry URL:</label>
        <input id="inq_url" type="text" placeholder="Enter Inquiry URL" class="form-input" formControlName="inq_url" />
        <form-error [form]="form" controlName="inq_url" [validations]="MasterProviderFormValidations.inq_url"></form-error>
    </div>
    
    <div>
        <label for="pay_url">Payment URL:</label>
        <input id="pay_url" type="text" placeholder="Enter Payment URL" class="form-input" formControlName="pay_url" />
        <form-error [form]="form" controlName="pay_url" [validations]="MasterProviderFormValidations.pay_url"></form-error>
    </div>
    
    <div>
        <label for="adv_url">Advice URL:</label>
        <input id="adv_url" type="text" placeholder="Enter Advice URL" class="form-input" formControlName="adv_url" />
        <form-error [form]="form" controlName="adv_url" [validations]="MasterProviderFormValidations.adv_url"></form-error>
    </div>
    
    <div>
        <label for="reversal_url">Reversal URL:</label>
        <input id="reversal_url" type="text" placeholder="Enter Reversal URL" class="form-input" formControlName="reversal_url" />
        <form-error [form]="form" controlName="reversal_url" [validations]="MasterProviderFormValidations.reversal_url"></form-error>
    </div>

    <div>
        <label for="callback_url">Callback URL:</label>
        <input id="callback_url" type="text" placeholder="Enter Callback URL" class="form-input" formControlName="callback_url" />
        <form-error [form]="form" controlName="callback_url" [validations]="MasterProviderFormValidations.callback_url"></form-error>
    </div>

    
      <button
        [disabled]="form.invalid"
        type="button"
        class="btn btn-success mt-4 w-full md:w-[180px]"
        (click)="saveData()"
      >
        <span
          *ngIf="loading"
          class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"
        ></span>
        Submit
      </button>
    </form>
  </div>
</div>
